import { highlight, matchLength, regExp } from './functions';
import getStates from './searchable-states';

export class Controller {

    /** @ngInject */
    constructor($scope, $state, $translate) {
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
    }

    $onInit() {
        this.$scope.$on('breadcrumb-data-changed', () => this.init());
        this.$scope.$on('language-loaded', () => this.init());
        this.init();
    }

    async init() {
        this.allItems = await Promise.all(getStates().map(name =>
            Promise.all(name
                .split('.')
                .map((token, index, tokens) => tokens.slice(0, index + 1).join('.'))
                .map(breadcrumb => this.$translate(`${breadcrumb}.$title`).catch(() => ''))
            )
                .then(breadcrumbs => breadcrumbs.filter(Boolean))
                .then(breadcrumbs => breadcrumbs.reverse())
                .then(breadcrumbs => ({name, breadcrumbs}))
        ));

        this.searchText = '';
        this.filter();
    }

    filter() {
        const input = this.searchText;

        if (!input) {
            this.filteredItems = [];
            return;
        }

        const regexp = regExp(input);

        this.filteredItems = this.allItems
            .filter(({breadcrumbs, name}) => [name, ...breadcrumbs].some(b => regexp.test(b)))
            .map(({breadcrumbs, name}) => ({
                name,
                breadcrumbs: breadcrumbs.map(highlight(regexp)),
                score: [name, ...breadcrumbs].map(matchLength(regexp)).reduce((a, b) => a + b, 0)
            }));
    }

    handleSearchChange() {
        this.filter();
        this.openDropdown();
    }

    handleSelect(state) {
        this.$state.go(state.name).then(() => this.init());
    }

    openDropdown() {
        this.dropdownIsOpen = !!this.searchText && !!this.filteredItems.length;
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-global-search/sp-global-search.controller.js